import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emojiPickerHeader: {
		id: 'polaris-ideas.right-sidebar.idea-templates.common.emoji-picker.emoji-picker-header',
		defaultMessage: 'Emoji',
		description: 'Header text for the polaris emoji picker',
	},
});
